function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { withSpacing } from '../lib/hoc/withSpacing';
import { theme } from '../styles';
import { shade, themify, tint } from '../styles/mixins';

const trackStyles = x => css(["height:", ";border:", ";border-radius:", ";background:", ";transition:all 0.15s ", ";"], x.$trackHeight, `${x.$trackBorderWidth} solid ${shade(0.9, x.$trackBgColor)}`, x.$trackRadius, x.$trackBgColor, theme.curves.standard);

const focusedTrackStyles = x => css(["background:", ";border-color:", ";box-shadow:inset 0 0 2px ", ";transition:all 0.15s ", ";"], tint(0.8, x.$trackBgColor), tint(0.9, x.$trackBgColor), shade(0.9, x.$trackBgColor), theme.curves.standard);

const thumbStyles = x => css(["margin-top:", ";width:", ";height:", ";border:", ";border-radius:", ";background:", ";transition:all 0.15s ", ";"], `calc(((-${x.$trackBorderWidth} * 2 + ${x.$trackHeight}) / 2) - (${x.$thumbSize} / 2))`, x.$thumbSize, x.$thumbSize, `${x.$thumbBorderWidth} solid ${shade(0.8, x.$thumbBgColor)}`, x.$thumbRadius, `linear-gradient(45deg, ${x.$thumbBgColor}, ${tint(0.1, x.$thumbBgColor)})`, x.theme.curves.standard);

const focusedThumbStyles = x => css(["background:", ";border-color:", ";"], `linear-gradient(135deg, ${x.$thumbBgColor}, ${tint(0.1, x.$thumbBgColor)})`, shade(0.85, x.$thumbBgColor));

const StyledRangeWrapper = styled.div.withConfig({
  displayName: "Range__StyledRangeWrapper",
  componentId: "sc-17qtlqs-0"
})(["position:relative;width:100%;"]);
const StyledRange = styled.input.withConfig({
  displayName: "Range__StyledRange",
  componentId: "sc-17qtlqs-1"
})(["margin:0;padding:0;width:100%;cursor:pointer;appearance:none;&::-webkit-slider-runnable-track{appearance:none;", "}&::-webkit-slider-thumb{appearance:none;", "}&::-moz-range-track{", "}&::-moz-range-thumb{", "}&::-moz-focus-inner{border:0;outline:0;}&::-ms-track{border-color:transparent;border-radius:", ";border-width:", ";background:transparent;color:transparent;}&::-ms-fill-lower{", " border-radius:", ";}&::-ms-fill-upper{", " border-radius:", ";}&::-ms-thumb{", "}&::-ms-tooltip{display:none;}&:focus{outline:none;& ~ output{visibility:visible;}&::-webkit-slider-runnable-track{", "}&::-webkit-slider-thumb{", "}&::-moz-range-track{", "}&::-moz-range-thumb{", "}&::-ms-fill-lower{", "}&::-ms-fill-upper{", "}}"], x => trackStyles(x), x => thumbStyles(x), x => trackStyles(x), x => thumbStyles(x), x => x.$trackRadius, x => x.$trackBorderWidth, x => trackStyles(x), x => `${x.$trackRadius} 0 ${x.$trackRadius} 0`, x => trackStyles(x), x => `0 ${x.$trackRadius} 0 ${x.$trackRadius}`, x => thumbStyles(x), x => focusedTrackStyles(x), x => focusedThumbStyles(x), x => focusedTrackStyles(x), x => focusedThumbStyles(x), x => focusedTrackStyles(x), x => focusedTrackStyles(x));
const RangeLabel = styled.label.withConfig({
  displayName: "Range__RangeLabel",
  componentId: "sc-17qtlqs-2"
})(["font-size:", ";color:", ";"], x => x.theme.type.scale[x.$labelSize], x => x.$labelColor);
const RangeValue = styled.output.withConfig({
  displayName: "Range__RangeValue",
  componentId: "sc-17qtlqs-3"
})(["position:absolute;visibility:hidden;top:100%;left:", ";background:", ";color:white;font-size:", ";font-weight:500;padding:0.25em 0.5em;text-align:center;border-radius:3px;transform:", ";backface-visibility:hidden;"], x => `calc(${x.$offsetLeft} * ${x.$width})`, themify('grayDarker'), x => x.theme.type.scale[6], x => `translateX(calc(${x.$offsetLeft} * -100%))`);

const RangeFunc = (_ref) => {
  let {
    className,
    error,
    id,
    label,
    labelColor = 'grayDark',
    labelSize = 6,
    max,
    min,
    showValue = true,
    touched,
    thumbBgColor = 'grayLight',
    thumbBorderWidth = '0.5px',
    thumbRadius = '50%',
    thumbSize = '18px',
    trackBgColor = 'green',
    trackBorderWidth = '1px',
    trackHeight = '9px',
    trackRadius = '999px',
    value,
    width = '100%'
  } = _ref,
      inputProps = _objectWithoutProperties(_ref, ["className", "error", "id", "label", "labelColor", "labelSize", "max", "min", "showValue", "touched", "thumbBgColor", "thumbBorderWidth", "thumbRadius", "thumbSize", "trackBgColor", "trackBorderWidth", "trackHeight", "trackRadius", "value", "width"]);

  const calcValueLabelOffset = () => {
    if (value === undefined || min === undefined || max === undefined) {
      return 0;
    }

    return (value - min) / (max - min);
  };

  return /*#__PURE__*/React.createElement(StyledRangeWrapper, {
    className: className
  }, label && /*#__PURE__*/React.createElement(RangeLabel, {
    htmlFor: id,
    $labelColor: themify(labelColor),
    $labelSize: labelSize
  }, label), /*#__PURE__*/React.createElement(StyledRange, _extends({
    $thumbBgColor: themify(thumbBgColor),
    $thumbBorderWidth: thumbBorderWidth,
    $thumbRadius: thumbRadius,
    $thumbSize: thumbSize,
    $trackBgColor: themify(touched && error ? 'red' : trackBgColor),
    $trackBorderWidth: trackBorderWidth,
    $trackHeight: trackHeight,
    $trackRadius: trackRadius,
    type: "range",
    value: value != null ? value : 0,
    min: min,
    max: max
  }, inputProps)), showValue && /*#__PURE__*/React.createElement(RangeValue, {
    htmlFor: id,
    $offsetLeft: calcValueLabelOffset(),
    $width: width
  }, value != null ? value : 0));
};

export const Range = withSpacing(RangeFunc, {
  mb: 2
});